import { Component } from '@angular/core';
import { FormGroup, FormArray, FormControl, FormBuilder } from '@angular/forms';
import { SchedularServiceService } from '../Services/Schedular/schedular-service.service';
import { IElement } from 'src/app/models/IElement';
import { HttpClient } from '@angular/common/http';

import { DataSource } from '@angular/cdk/table';
import { Observable } from 'rxjs';
import { MatTableDataSource } from '@angular/material';
/**
 * @title Basic table
 */
@Component({
  selector: 'app-test',
  styleUrls: ['./test.component.css'],
  templateUrl: './test.component.html'
})
export class TestComponent {
  displayedColumns = ['position', 'name', 'weight', 'symbol', 'active2', 'anotherDropdown'];
  activeList = ['Yes', 'No'];
  dataSource: MatTableDataSource<IElement>;
  dataSource2: IElement[] = [];
  testform: FormGroup;
  ngOnInit() {
    this.testform = this.fb.group(
      {
        testtable: this.fb.array([])   
      });
    }
  
  constructor(private fb: FormBuilder, private scheduler : SchedularServiceService,private http : HttpClient) { 
      this.bindData();
  }
  bindData() {
    this.dataSource = new MatTableDataSource();
    // this.scheduler.TestMethod()
    // .subscribe(
    //   (
    //     app: IElement[]) => {
    //     if (app != null) {
    //       app.forEach(ele => {
    //       var obj: IElement = {
    //         name: ele.name, weight: ele.weight ,active: ele.active, anotherDropdown:ele.anotherDropdown ,position:ele.position,symbol:ele.symbol
    //       }   
    //       if (this.dataSource2 != undefined) {
    //         this.dataSource2.push(obj);
    //       }
    //     })
    //     this.dataSource.data = this.dataSource2;
    //     this.initializeTestTable();
    //                       }      
    //          }
    // );

  }

  initializeTestTable() {
    const testtable = this.testform.get('testtable') as FormArray;
    testtable.clear();
    this.dataSource.data.forEach((ele) => {
      testtable.push(this.createTestArray(ele))
    })
  }

  createTestArray(ele) {
    return this.fb.group({
      activestatus: [ele.active],
      anotherDropdown: [ele.anotherDropdown]
    });
  }


}




  